import { isIOS, isSafari } from 'react-device-detect';
import { Box, Typography } from '@mui/material';
import { translate } from 'translations/translator';

const t = key => translate('worksheet', key);

const fontStyle = {
  fontSize: '20px',
  fontFamily: 'Futura-Semibold'
};

const SignAndDate = () => {
  return (
    <Box
      id="signAndDate"
      sx={{
        marginBottom: '-30px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        ...(isIOS || isSafari ? { '@media print': { marginBottom: '20px' } } : {})
      }}
    >
      <Typography sx={fontStyle}>{t('signed')}: </Typography>
      <Typography sx={{ marginLeft: '5px' }}>_________________________________</Typography>
      <Typography sx={{ marginLeft: '50px', ...fontStyle }}>
        {t('date')}: {''}
      </Typography>
      <Typography sx={{ marginLeft: '5px' }}>____________________</Typography>
    </Box>
  );
};

export default SignAndDate;
